import React from "react";
import {
  SEAT_ROLE_TITLE,
  availableSeatsText,
  occupiedSeatsLine,
  pendingInvitationsText,
  reservedSeatsLine,
} from "../../lib/memberManagement";

/**
 * The AUTHORITATIVE seat picture, one card per role the actor may see.
 *
 * Every number comes from the invitation list endpoint, which reads
 * private.org_role_seat_usage. The browser adds nothing up: "заети места" is the
 * database's own usage figure and it INCLUDES pending, non-expired invitations,
 * which is exactly why the breakdown underneath spells out how many are active
 * users and how many are reserved by an invitation.
 *
 * An Owner sees manager and sales seats; a Manager sees sales seats only,
 * because the RPC returns nothing else to a Manager.
 */
export const UserSeatSummary = ({ seats }) => {
  const roles = ["manager", "sales"].filter((role) => seats && seats[role]);
  if (roles.length === 0) return null;

  return (
    <div className="qw-grid cols-2" data-testid="user-seat-summary">
      {roles.map((role) => {
        const seat = seats[role] || {};
        const over = Number(seat.usage) > Number(seat.limit);
        const reserved = reservedSeatsLine(seat.pending_invitations);
        return (
          <div className="qw-card" key={role} data-testid={`seat-card-${role}`}>
            <div className="card-title">{SEAT_ROLE_TITLE[role]}</div>
            <div
              className="card-value"
              style={over ? { color: "#b91c1c" } : undefined}
              data-testid={`seat-card-${role}-occupied`}
            >
              {occupiedSeatsLine(seat)}
            </div>
            <div className="qw-seat-breakdown">
              <div data-testid={`seat-card-${role}-active`}>
                Активни потребители: <strong>{Number(seat.active_members) || 0}</strong>
              </div>
              <div data-testid={`seat-card-${role}-pending`}>
                Чакащи покани: <strong>{Number(seat.pending_invitations) || 0}</strong>
              </div>
              <div data-testid={`seat-card-${role}-available`}>
                Свободни места: <strong>{Number(seat.available) || 0}</strong> от{" "}
                {Number(seat.limit) || 0}
              </div>
            </div>
            {reserved && (
              <div className="qw-help" data-testid={`seat-card-${role}-reserved`}>
                {reserved}
              </div>
            )}
            <div className="qw-visually-hidden" data-testid={`seat-card-${role}-summary`}>
              {SEAT_ROLE_TITLE[role]}: {availableSeatsText(seat.available)},{" "}
              {pendingInvitationsText(seat.pending_invitations)}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default UserSeatSummary;
